<template>
  <div class="m-flex-row m-fir-detail">
    <div class="m-flex-row">
      <!--左边按钮-->
      <div
        v-if="listdata && listdata.length > 0"
        class="m-debtn m-left-btn"
        :class="{ 'm-left-btn-disable': serindex <= 0 }"
        @click="changeSer('left')"
      ></div>
      <!--中间内容-->
      <div class="m-body-ser" ref="bodyser">
        <template v-for="(item, index) in listdata">
          <div class="m-flex-row m-service" :style="serItemStyle(index)">
            <div class="m-flex-cloumn m-deta-left">
              <div class="m-left-title">{{ item.name }}</div>
              <div class="m-left-description">{{ item.description }}</div>
              <div class="order-price">
                <span>¥</span>
                <span>{{ item.amount / 100 }}</span>
                <span>定金</span>
              </div>
              <div class="m-bottom-btn">
                <div class="primary-btn" @click="getSerId(item.id)">
                  立即预定
                </div>
              </div>
            </div>
            <div class="m-desc" ref="mdesc">
              <div class="service-info">服务内容</div>
              <template v-if="item.infos" v-for="(info, num) in item.infos">
                <div class="m-sercon" v-show="num < shownum">
                  <!-- <img src="../../assets/images/ic-select-2x.png" /> -->
                  <span></span>
                  <div>{{ info.name }}</div>
                </div>
              </template>
              <div
                class="m-more"
                v-show="item.infos && item.infos.length > 5 && shownum <= 5"
              >
                <div class="m-border"></div>
                <div>
                  <a class="m-font12 m-cor4E" @click="showSer(index)">详情</a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!--右边按钮-->
      <div
        v-if="listdata && listdata.length > 0"
        class="m-debtn m-right-btn"
        :class="{ 'm-right-btn-disable': serindex >= listdata.length - 1 }"
        @click="changeSer('right')"
      ></div>
    </div>
  </div>
</template>
<script>
import api from "../../config/api.js";
export default {
  name: "service",
  data: function () {
    return {
      serindex: 1,
      shownum: 10,
      listdata: [],
      sourceName: "",
    };
  },
  computed: {},
  created: function () {
    //获取数据
    this.getData();
    let str = window.location.search;
    this.sourceName = str.split("=")[1];
    console.log("来源", this.sourceName);
  },
  methods: {
    getData: function () {
      let vm = this;
      let url = api.API_URL + "wedding/v1/service/list"; //获取描述数据等
      let that = this;
      vm.getAjax(
        url,
        "",
        function (result) {
          if (result.rcode == "000000" && result.rdata) {
            result.rdata.forEach((item, index) => {
              if (
                that.sourceName == "echoey" &&
                item.id == "a9a38f5e-b48d-11e7-9684-3497f69b9fee"
              ) {
                that.serindex = index;
              }
            });
            vm.listdata = result.rdata;
          }
        },
        function () {}
      );
    },
    serItemStyle: function (n) {
      let leftva = 0;
      if (n == this.serindex) {
        leftva = 0;
      } else if (n > this.serindex) {
        leftva = (n - this.serindex) * 816;
      } else {
        leftva = -(this.serindex - n) * 816;
      }
      return { left: leftva + "px", opacity: n == this.serindex ? 1 : 0 };
    },
    changeSer: function (type) {
      if (type == "left") {
        if (this.serindex > 0) {
          this.serindex = this.serindex - 1;
        }
      } else {
        if (this.serindex < this.listdata.length - 1) {
          this.serindex = this.serindex + 1;
        }
      }
    },
    showSer: function (index) {
      //展示更多
      this.shownum = 100;
      $(".m-body-ser").css("height", "450px");
      $(".m-desc").css("height", "450px");
    },
    getSerId: function (id) {
      let obj = { cuindex: 1, menuIndex: 1 };
      this.bus.$emit("updateIndex", obj);
      let datainfo = { serviceId: id };
      //添加历史记录
      window.history.pushState("", null, "");
      this.bus.$emit("updateData", datainfo);
    },
  },
  mounted() {},
};
</script>
<style>
.m-body-ser {
  position: relative;
  width: 816px;
  min-height: 384px;
  overflow-x: hidden;
}
.m-service {
  position: absolute;
  left: 0;
  top: 0;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.m-fir-detail {
  margin-top: 113px !important;
}
.m-fir-detail .m-desc {
  width: 400px;
  margin-left: -2px;
  height: 380px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// selelct-service.vue?36c2f953